import PasswordResetCard from "../PasswordResetCard";

export default function PrivacyCard() {
  return (
    <div className="w-full">
      <PasswordResetCard variant="plain" title="Privacy" />
    </div>
  );
}

